import baseApi from "@/api/baseApi";

const api = {
  async getTask(data) {
    const response = await baseApi({
      method: "post",
      url: `/tasks`,
      data: data,
    });

    return response.data;
  },
  async getTaskCount(data) {
    const response = await baseApi({
      method: "post",
      url: `/tasks/count`,
      data: data,
    });

    return response.data;
  },

  async getFilteroptions() {
    const response = await baseApi({
      method: "get",
      url: `/tasks/filteroptions`,
      data: { hideLoader: true },
    });

    return response.data;
  },
};

export default api;
